var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 799,
    viewBox: "0 0 1440 799",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_9827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-230.428 245.56C-230.428 269.661 -369.309 240.236 -369.309 264.337C-391.047 273.911 -420.516 283.48 -446.08 292.629C-481.909 305.451 -534.627 319.887 -535.967 335.535C-537.489 353.302 -485.939 376.646 -405.573 383.283C-370.876 386.149 -313.437 383.3 -278.265 382.009C-232.315 380.322 -179.344 373.085 -148.642 365.271C-97.5083 352.258 -70.7906 332.793 8.7569 327.888C67.4873 324.267 145.989 383.156 207.082 383.283C282.831 383.441 359.82 388.449 425.049 396.962C546.849 412.858 630.269 435.029 709.37 460.598C757.335 476.103 792.014 492.223 853.266 505.713C932.91 523.253 1120.74 615.444 1220.41 626.869C1433.51 651.294 1717.35 654.476 1934.88 630.522C2048.37 618.025 2137.41 594.694 2105.01 565.356C2074.18 537.438 1985.36 514.878 1853.87 510.471C1708.87 505.612 1555.43 515.069 1412.53 505.713C1330.5 500.342 1257.99 488.152 1191.87 476.826C1102.15 461.459 909.67 364.602 844.394 343.691C750.131 313.495 693.696 272.521 551.971 250.913C504.155 243.622 455.276 236.469 395.343 236.469C316.552 236.469 240.46 180.939 162.684 184.133C64.5505 188.162 -33.4293 197.711 -109.292 212C-153.5 220.327 -230.428 231.193 -230.428 245.56Z",
    fill: "#AAE6FD",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_9827",
    x: -720,
    y: 0.000244141,
    width: 3015.75,
    height: 830.928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92,
    result: "effect1_foregroundBlur_31_9827"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.80974e6c05a2f73bdb00288d8a9cbdee.svg";
export { ForwardRef as ReactComponent };